// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { chain, LoadCart } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";

// XNG-changes: CES-636 - awaitableLoadCurrentCart
export const xLoadCart: typeof LoadCart = async props => {
    const awaitableLoadCurrentCart = makeHandlerChainAwaitable(loadCurrentCart);
    await awaitableLoadCurrentCart({ shouldLoadFullCart: true })(props.dispatch, props.getState);
};

replaceInChain(chain, LoadCart, xLoadCart);
